import { settings } from 'settings';
import Fetch from 'utils/fetch';

export interface PerformanceScan {
  day: string;
  scannedBy?: number;
  firstName: string;
  lastName: string;
  nrOfFirstScans?: number;
  totalNrOfScans?: number;
  nrOfCompletedScans?: number;
  firstScan?: string;
}

export async function fetchScanPerformance(
  startDate: string,
  endDate: string
): Promise<PerformanceScan[]> {
  try {
    const response: Response = await Fetch.put({
      url: `${settings.newApiUrl}/scan/scanPerformance?start=${startDate}&end=${endDate}`,
    });

    if (response.ok) {
      const performanceScanList: PerformanceScan[] = await response.json();
      return performanceScanList;
    }
  } catch (error) {
    return [];
  }
}
